export default (info, metaData) => {
  return {
    "@context": "https://schema.org/",
    "@type": "WebSite",
    name: info.facilityName,
    url: metaData.siteUrl,
  }
}
